/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { delivery } from "../assets/delivery";
import { Icon, type IconBaseProps } from "../icon";

export const IconDelivery = (props: IconBaseProps) => <Icon {...props} svg={delivery} />;

IconDelivery.displayName = "IconDelivery";
